import { useEffect, useRef } from 'react';
import classNames from 'classnames';

import lang from '../../../lib/language';

import AddIcon from '../../../assets/img/icon-check-dark-green.svg';
import IconClose from '../../../assets/img/icon-close-black.svg';
import RemoveIcon from '../../../assets/img/icon-close-dark-red.svg';
import ClickableImage from '../../ClickableImage/ClickableImage';

import styles from './FavouritesModal.module.scss';

type Props = {
    isAddedToFavourites: boolean;
    isRemovedFromFavourites: boolean;
    symbol: string
    closeModal: () => void;
    isMobile?: boolean;
    isWatchlist?: boolean;
    isSearch?: boolean;
    isSymbolDetails?: boolean;
}

const FavouritesModal = ({
  isAddedToFavourites,
  isRemovedFromFavourites,
  symbol,
  closeModal,
  isMobile,
  isWatchlist,
  isSearch,
  isSymbolDetails,
} : Props) => {
  const favouritesRef = useRef<HTMLElement>() as React.RefObject<HTMLDivElement>;

  // close favourites modal
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (favouritesRef.current && !favouritesRef.current.contains(event.target as HTMLDivElement)) {
        closeModal();
      }
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [closeModal]);

  return (
    <div
      className={classNames(styles.addToFavouritesMsg,
        { [styles.mobileWrapper]: isMobile },
        { [styles.watchListMobileWrapper]: isMobile && isWatchlist },
        { [styles.searchMobileWrapper]: isMobile && isSearch },
        { [styles.symbolDetailsMobileWrapper]: isMobile && isSymbolDetails })}
      ref={favouritesRef}
      onBlur={() => closeModal()}
    >
      <div className={styles.wrapperContent} id="favouritesModalMessage">
        <div className={styles.wrapperCheckmark}>
          <img
            className={styles.checkmark}
            src={isAddedToFavourites ? AddIcon : RemoveIcon}
            alt="Add to favourites"
          />
        </div>
        <div className={styles.text}>
          <span className={styles.symbol}>{symbol}</span>
          {isAddedToFavourites && lang.commonSymbolAddedToWatchlistMsg()}
          {isRemovedFromFavourites && lang.commonSymbolRemovedToWatchlistMsg()}
        </div>
      </div>
      <ClickableImage
        className={styles.icon}
        alt='Close "Add to favourites modal"'
        onClick={() => closeModal()}
        src={IconClose}
      />
    </div>
  );
};

export default FavouritesModal;
